import { useDispatch } from 'react-redux';
import { RESEND_MESSAGE_URL } from 'api/SentMessagesAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { MessageMedium } from 'constants/messageMediums';
import { useRestMutation } from 'utils/hooks/api';
import { ApiError, ApiMethod } from 'services/api';

interface ResendMessageRequest {
  messageId: string;
  recipient: string;
  messageMedium: MessageMedium;
}

interface ResendMessage {
  campaignName: string;
  requestParams: ResendMessageRequest;
}

export const useResendMessage = ({ campaignName, requestParams }: ResendMessage) => {
  const { messageId, messageMedium, recipient } = requestParams;
  const dispatch = useDispatch();
  const onError = (error: unknown) => {
    const detailedError = error instanceof ApiError ? error?.response?.data : undefined;
    const errorMessage = detailedError
      ? `Unable to resend message. ${detailedError}.`
      : 'Unable to resend message. Please try again later.';
    dispatch(addNegativeToast(errorMessage));
  };

  const onSuccess = () => {
    dispatch(addPositiveToast(`${campaignName} resent to ${recipient}`));
  };
  const { mutate, isLoading } = useRestMutation(RESEND_MESSAGE_URL, ApiMethod.post, {
    onSuccess,
    onError,
  });
  const resendMessage = () => mutate({ messageId, messageMedium, recipient });

  return { resendMessage, isLoading };
};
